var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMileage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.181 7.492A10.46 10.46 0 0 0 1.606 13H4.25a.75.75 0 0 1 0 1.5H1.5c0 1.72.413 3.341 1.144 4.772a.75.75 0 1 1-1.335.683A11.95 11.95 0 0 1 0 14.5c0-6.627 5.373-12 12-12 2.952 0 5.655 1.066 7.745 2.834l.451-.452a.75.75 0 1 1 1.061 1.06l-.429.43A11.96 11.96 0 0 1 24 14.5c0 1.963-.472 3.818-1.309 5.455a.75.75 0 1 1-1.335-.683A10.45 10.45 0 0 0 22.5 14.5h-2.75a.75.75 0 0 1 0-1.5h2.644a10.46 10.46 0 0 0-2.628-5.567l-5.223 5.224a3 3 0 1 1-1.09-1.032l5.227-5.227a10.45 10.45 0 0 0-5.93-2.372V6.5a.75.75 0 0 1-1.5 0V4.026A10.45 10.45 0 0 0 5.26 6.45l2.099 2.099a.75.75 0 0 1-1.06 1.06L4.18 7.493zM12 15.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  clipRule: "evenodd"
})));
export default SvgMileage;